/* eslint-disable */

import * as utils from '../functions/utils';
import { CATEGORY_ID } from '../constants/category';
import { IMeetingType } from 'redhotpie-shared-lib/interfaces/IDateFinder';

export default class dateFinderMeetingType {
  id: number;
  name: string;
  listId: number;
  constructor() {
    this.id = 0;
    this.name = '';
    this.listId = 0;
  }

  static mappingPropertyObject(object: any): IMeetingType {
    const newObject = new dateFinderMeetingType();
    newObject.id = object.ItemID || 0;
    newObject.name = object.ItemName || '';
    newObject.listId = object.ListID || 0;

    return newObject;
  }

  static getIconObjects(propertyItems: any[]) {
    const _propertyItems: any[] = [];
    propertyItems.forEach(property => {
      property.icSrc = utils.getIconCategoryItem(CATEGORY_ID.MEETING_TYPE, property.id);
      _propertyItems.push(property);
    });
    return _propertyItems;
  }

  static mappingPropertyObjects(_objects: any[]): IMeetingType[] {
    const results: IMeetingType[] = [];
    _objects.forEach(_object => {
      const object = dateFinderMeetingType.mappingPropertyObject(_object);
      results.push(object);
    });
    return results;
  }
}
